// extracted by mini-css-extract-plugin
export var boldFontWeight = "700";
export var errorContainer = "dC_pX";
export var errorTitle = "dC_pY";
export var fontFamily = "Neuzeit Grotesk";
export var fontStack = "Neuzeit Grotesk,Helvetica Neue,Helvetica,Arial,sans-serif";
export var harbourBoldFontFamily = "ITC Avant Garde Pro Demi";
export var harbourBoldFontStack = "ITC Avant Garde Pro Demi,sans-serif";
export var harbourBoldFontWeight = "600";
export var harbourRegularFontFamily = "ITC Avant Garde Pro Bk";
export var harbourRegularFontStack = "ITC Avant Garde Pro Bk,sans-serif";
export var harbourRegularFontWeight = "300";
export var lightFontWeight = "300";
export var regularFontWeight = "400";